import { legacy_createStore as createStore, combineReducers } from 'redux';
import { baseReducersMap } from 'shared/store/reducers';
import { middleware } from 'shared/store/middlewares';
import { storageMiddleware } from './middleware/storage.middleware';
import knowledgeViewerReducer from './reducers/knowledgeViewer.reducer';
import labViewerReducer from './reducers/labViewer.reducer';
import admissionViewerReducer from './reducers/admission-viewer.reducer';
import { analyticsMiddleware } from './middleware/analytics.middleware';
import { langMiddleware } from './middleware/lang-local.middleware';
import { remoteConfigMiddleware } from './middleware/remoteConfig.middleware';
import { switchOrganizationMiddleware } from './middleware/switch-organization.middleware';

/**
 * @typedef {import('redux').ActionFromReducersMapObject<typeof reducersMap>} StoreAction
 * @typedef {import('redux').StateFromReducersMapObject<typeof reducersMap>} StoreState
 */

const reducersMap = {
  ...baseReducersMap,
  knowledgeViewer: knowledgeViewerReducer,
  labViewer: labViewerReducer,
  admissionViewer: admissionViewerReducer,
};

export const createStoreAction = () =>
  createStore(
    combineReducers(reducersMap),
    {},
    middleware([
      ...remoteConfigMiddleware,
      ...storageMiddleware,
      ...analyticsMiddleware,
      ...langMiddleware,
      ...switchOrganizationMiddleware,
    ]),
  );

export const store = createStoreAction();

global.store = store;
